<template>
  <div class="offerInfo">
    <div class="content">
      <div
        v-if="soldCount > 1000 && [2, 5, 8].includes(soldCount % 10)"
        class="bestseller"
      >
        Bestseller
      </div>
      <div class="content-title">
        {{ offerData?.subjectTrans }}
      </div>
      <div class="product-rating">
        <template v-if="offerData?.sellerDataInfo && Number(offerData?.sellerDataInfo?.compositeServiceScore) > 0">
          <div class="star-rating">
            <Rate :value="offerData?.sellerDataInfo?.compositeServiceScore" />
            <div class="rating-num">
              {{ Number(offerData?.sellerDataInfo?.compositeServiceScore).toFixed(1) }}
            </div>
          </div>
        </template>
        <template v-if="soldCount > 0">
          <div
            v-if="offerData?.sellerDataInfo && Number(offerData?.sellerDataInfo?.compositeServiceScore) > 0"
            class="separator"
          />
          <div class="sold-count">
            <span>{{ formatSalesVolume(soldCount) }}</span> sold
          </div>
        </template>
        <template v-if="showAdding">
          <div class="separator" />
          <div class="adding-cart">
            {{ addingCount }} adding to cart
          </div>
        </template>
        <template v-if="!showAdding && Number(offerData?.sellerDataInfo?.repeatPurchasePercent) > 0">
          <div class="separator" />
          <div class="custom-rate">
            Customer reorder rate <span>{{ (offerData?.sellerDataInfo?.repeatPurchasePercent * 100).toFixed(0) }}</span>%
          </div>
        </template>
      </div>
      <PriceRange
        v-if="offerData?.productSaleInfo?.priceRangeList?.length >= 2"
        :price-range-list="offerData?.productSaleInfo?.priceRangeList"
        :currency-data="currencyData"
      />
      <PriceRange
        v-else
        style="width: 120px;"
        :price-range-list="minPriceRange"
        :currency-data="currencyData"
      />
      <div class="line" />

      <!-- sku不存在的情况下，目前基本不存在该情况，保留此展示为防止 1688 接口异常兜底 -->
      <div
        class="noAttribute-main"
        v-if="!offerData?.productSkuInfos"
      >
        <div class="noAttributes">
          <div class="secondAttributes-price">
            <span>
              {{ currencyData?.targetCurrency?.slice(0, 2) }}
              {{ currencyData?.targetUnit }}{{ bankersRound(renderNoSkuPrice() * currencyData?.rate, 2) }}
            </span>
          </div>
          <div class="secondAttributes-inStock">
            {{ offerData?.productSaleInfo?.amountOnSale }} InStock
          </div>

          <div class="secondAttributes-btn">
            <div
              class="secondAttributes-btn-sub"
              @click="noAttributesSub()"
            >
              <img
                src="@/assets/offer/sub.svg"
                alt=""
              >
            </div>
            <input
              class="secondAttributes-btn-input"
              @change="(e) => changeNoAttributes(e)"
              v-model="noSkuNum"
            >
            <div
              class="secondAttributes-btn-add"
              @click="noAttributesAdd"
            >
              <img
                src="@/assets/offer/add.svg"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>

      <!-- sku存在的情况 -->
      <div v-if="!!offerData?.productSkuInfos">
        <div class="attributes">
          <div class="firstAttributes">
            <div class="firstAttributes-title">
              {{ firstrAttributes?.[0]?.attributeNameTrans }}:
              <span class="firstAttributes-title-sku">{{
                currentFirstSku
              }}</span>
            </div>
            <div class="firstAttributes-item">
              <div
                v-for="(item, index) in firstrAttributes"
                :key="index"
                @click="clickFirstAttributes(item, index)"
                :class="{
                  'firstAttributes-container': true,
                  activedAttributes: firstActivedAttributesIndex === index,
                }"
              >
                <Image
                  class="firstAttributes-container__image"
                  :src="item?.skuImageUrl || defaultImage"
                  alt=""
                />
                <div class="firstAttributes-item-title">
                  <span>
                    {{ item?.valueTrans }}
                  </span>
                </div>
                <div
                  class="firstAttributes-item-total"
                  v-if="item?.total"
                >
                  ×{{ item?.total }}
                </div>
              </div>
            </div>
          </div>
          <div class="secondAttributes">
            <div class="secondAttributes-title">
              <div>{{ secondAttributesQuantityList[0]?.skuAttributes?.[1]?.attributeNameTrans ?? 'Quantity' }}</div>
              <div class="min-order">
                Min. Order: <span>{{ offerData?.minOrderQuantity }} PCS</span>
              </div>
            </div>
            <div class="secondAttributes-item">
              <div
                v-for="(item, index) in secondAttributesQuantityList"
                :key="index"
                class="secondAttributes-container"
              >
                <span class="secondAttributes-valueTrans">
                  {{ item?.skuAttributes?.[1]?.valueTrans || '' }}
                </span>

                <div class="secondAttributes-price">
                  <span>
                    {{ currencyData?.targetCurrency?.slice(0, 2) }}
                    {{ currencyData?.targetUnit }}{{
                      bankersRound(
                        renderPrice(item?.price) * currencyData?.rate,
                        2
                      )
                    }}
                  </span>
                </div>
                <div class="secondAttributes-inStock">
                  {{ item?.amountOnSale }} in stock
                </div>

                <div class="secondAttributes-btn">
                  <div
                    class="secondAttributes-btn-sub"
                    @click="attributesSub(item, index)"
                  >
                    <img
                      :id="'secondAttributes-btn-sub-' + index"
                      :src="secondAttributesBtnReduce"
                      @mouseover="
                        (e) =>
                          secondAttributesBtnReduceHoverIn(e, item.quantity)
                      "
                      @mouseleave="
                        (e) =>
                          secondAttributesBtnReduceHoverOut(e, item.quantity)
                      "
                      alt=""
                    >
                  </div>
                  <input
                    class="secondAttributes-btn-input"
                    v-model="item.quantity"
                    type="number"
                    @change="(e) => changeAttributes(item, index, e)"
                  >
                  <div
                    class="secondAttributes-btn-add"
                    @click="attributesAdd(item, index)"
                  >
                    <img
                      :id="'secondAttributes-btn-add-' + index"
                      :src="secondAttributesBtnAdd"
                      @mouseover="
                        (e) =>
                          secondAttributesBtnAddHoverIn(
                            e,
                            item?.amountOnSale,
                            item.quantity
                          )
                      "
                      @mouseleave="
                        (e) =>
                          secondAttributesBtnAddHoverOut(
                            e,
                            item?.amountOnSale,
                            item.quantity
                          )
                      "
                      alt=""
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, toRaw, watch } from 'vue'
import { useStore } from 'vuex'
import defaultImage from '@/assets/empty-image.svg'
import { useIntercom } from '@/hooks/useIntercom'
import { Image } from '@/components/Image'

import { useRoute } from 'vue-router'
import { bankersRound, formatSalesVolume, debounce } from '../../../utils/utils'
import PriceRange from './components/priceRange.vue'
import Rate from '../../ProductItem/Rate.vue'
import { useCurrencyJudge } from '@/hooks/useCurrencyJudge'

const props = defineProps({
  sourcingStatusInfo: {
    type: Object,
    default: () => ({})
  }
})

const emits = defineEmits(['selectedSkuId'])

const store = useStore()
const intercom = useIntercom()

const offerData = computed(() => store.state.offerDetail)
const currencyData = computed(() => store.state.currencyData)

const firstrAttributes = ref([])
const firstActivedAttributesIndex = ref(0)

const secondAttributesQuantityList = ref([])

const currentFirstSku = ref('')

const soldOut = ref('')

const secondAttributesQuantityObj = reactive({})

const route = useRoute()

const minPriceRange = ref([])

const IMAGES = {
  addDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add_default.svg',
  add: 'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add.svg',
  reduceDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce_default.svg',
  reduce:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce.svg',
  irreducible:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/irreducible.svg',
  cannotBeAdded:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/cannot_be_added.svg'
}

const totalQuantity = ref(0)

const soldCount = computed(() => {
  if (route.query.key) {
    return atob(route.query.key)
  } else {
    return offerData.value.soldOut
  }
})

const showAdding = computed(() => {
  return route.query.adding && soldCount.value > 300 && offerData?.value.sellerDataInfo?.repeatPurchasePercent > 0.6 && [2, 3, 6, 7].includes(soldCount.value % 10)
})

const addingCount = computed(() => {
  return atob(route.query.adding)
})

const updateButtonImage = (element, src) => {
  if (element) {
    element.src = src
  }
}

// 添加按钮操作
const secondAttributesBtnAdd = ref(IMAGES.addDefault)
const secondAttributesBtnAddHoverIn = (e, amountOnSale, quantity) => {
  const imgElement = e.target
  if (imgElement) {
    const src = quantity >= amountOnSale ? IMAGES.cannotBeAdded : IMAGES.add
    updateButtonImage(imgElement, src)
  }
}

const secondAttributesBtnAddHoverOut = (e, amountOnSale, quantity) => {
  const imgElement = e.target
  if (imgElement) {
    const src = quantity >= amountOnSale ? IMAGES.cannotBeAdded : quantity > 0 ? IMAGES.add : IMAGES.addDefault

    updateButtonImage(imgElement, src)
  }
}

// 减少按钮操作
const secondAttributesBtnReduce = ref(IMAGES.irreducible)
const secondAttributesBtnReduceHoverIn = (e, quantity) => {
  const imgElement = e.target
  if (imgElement) {
    const src = quantity === 0 ? IMAGES.irreducible : IMAGES.reduce
    updateButtonImage(imgElement, src)
  }
}

const secondAttributesBtnReduceHoverOut = (e, quantity) => {
  const imgElement = e.target
  if (imgElement) {
    const src = quantity === 0 ? IMAGES.irreducible : IMAGES.reduceDefault
    updateButtonImage(imgElement, src)
  }
}

// watch 更新按钮图标
watch(
  secondAttributesQuantityList,
  (_1, _2) => {
    secondAttributesQuantityList.value?.forEach((item, i) => {
      const imgElementSub = document.getElementById(
        'secondAttributes-btn-sub-' + i
      )
      const imgElementAdd = document.getElementById(
        'secondAttributes-btn-add-' + i
      )

      if (item.quantity === 0) {
        updateButtonImage(imgElementSub, IMAGES.irreducible)
        updateButtonImage(imgElementAdd, IMAGES.addDefault)
      } else if (item.quantity >= item.amountOnSale) {
        updateButtonImage(imgElementSub, IMAGES.reduceDefault)
        updateButtonImage(imgElementAdd, IMAGES.cannotBeAdded)
      } else {
        if (imgElementSub.src !== IMAGES.reduce) {
          updateButtonImage(imgElementSub, IMAGES.reduceDefault)
        }

        if (imgElementAdd.src !== IMAGES.add) {
          updateButtonImage(imgElementAdd, IMAGES.addDefault)
        }
      }
    })
  },
  { deep: true }
)

// 无sku情况处理
const noSkuNum = ref(0)

const changeNoAttributes = (e) => {
  let value = Number(e.target.value.replace(/[^0-9]/g, ''))
  if (value >= offerData.value?.productSaleInfo?.amountOnSale) {
    value = offerData.value?.productSaleInfo?.amountOnSale
  }
  if (value <= 0) {
    value = 0
  }
  noSkuNum.value = Number(value)
  postNoskuPrice()
}

const noAttributesSub = () => {
  if (noSkuNum.value <= 0) {
    noSkuNum.value = 0
    return
  }
  noSkuNum.value = Number(noSkuNum.value) - 1
  postNoskuPrice()
}

const noAttributesAdd = () => {
  if (noSkuNum.value >= offerData.value?.productSaleInfo?.amountOnSale) {
    noSkuNum.value = Number(offerData.value?.productSaleInfo?.amountOnSale)
    return
  }
  noSkuNum.value = Number(noSkuNum.value) + 1
  postNoskuPrice()
}

const renderNoSkuPrice = () => {
  const matchedPrice = offerData.value?.productSaleInfo?.priceRangeList
    .filter((range) => noSkuNum.value >= range.startQuantity)
    .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price

  if (!matchedPrice) {
    return offerData.value?.productSaleInfo?.priceRangeList[0]?.price
  }
  return matchedPrice
}

const postNoskuPrice = async () => {
  const matchedPrice = offerData.value?.productSaleInfo?.priceRangeList
    .filter((range) => noSkuNum.value >= range.startQuantity)
    .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price ||
    offerData?.productSaleInfo?.priceRangeList[0]?.price

  // sourcing now逻辑
  if (props.sourcingStatusInfo?.status === 4) {
    const obj = {
      ...offerData.value.productShippingInfo?.defaultShippingInfo,
      price: matchedPrice,
      quantity: noSkuNum.value,
      targetPrice: bankersRound(matchedPrice * currencyData.value.rate, 2)
    }
    const logisticFeeProductInputs = [
      {
        offerId: offerData.value.offerId,
        titleCn: offerData.value.subject,
        categoryId: offerData.value.categoryId,
        productUrl: window.location.href,
        skuShipInfos: [obj]
      }
    ]

    if (!matchedPrice) {
      store.commit('setMergedArray', logisticFeeProductInputs)
      return
    }
    store.commit('setMergedArray', [obj])
    return
  }
  const obj = {
    spuId: offerData.value.offerId,
    quantity: noSkuNum.value,
    spuName: offerData.value.subjectTrans,
    batchNum: offerData.value.minOrderQuantity,
    targetPrice: bankersRound(matchedPrice * currencyData.value.rate, 2)
  }

  store.commit('setMergedArray', [obj])
}

const onContact = () => {
  intercom.showNewMessage()
}

const renderPrice = (price) => {
  if (!price) {
    const skuSales = []
    let totalQuantity = 0
    Object.entries(secondAttributesQuantityObj).forEach(([, value]) => {
      value.forEach((v) => {
        if (v?.quantity > 0) {
          skuSales.push(toRaw(v))
        }
      })
    })
    skuSales.forEach((v) => {
      totalQuantity += v.quantity
    })

    const matchedPrice = offerData.value?.productSaleInfo?.priceRangeList
      .filter((range) => totalQuantity >= range.startQuantity)
      .sort((a, b) => b.startQuantity - a.startQuantity)[0]?.price

    if (!matchedPrice) {
      return offerData.value?.productSaleInfo?.priceRangeList?.[0]?.price
    }

    if (matchedPrice) {
      return matchedPrice
    }
  } else {
    return price
  }
}

watch(offerData, (newData) => {
  if (newData) {
    offerData.value = newData
    firstSku(newData?.productSkuInfos)
    const { key } = route.query

    const decodedKey = key ? atob(key) : null
    soldOut.value = decodedKey
      ? Math.max(decodedKey, newData?.soldOut || 0)
      : newData?.soldOut

    document.title = newData?.subjectTrans
  }
})

const handleMinPriceRange = () => {
  let price = secondAttributesQuantityList.value[0].price

  secondAttributesQuantityList.value.forEach(item => {
    const p = Number(item.price)
    if (price > p) {
      price = p
    }
  })
  minPriceRange.value = [{
    startQuantityStr: '>=' + offerData.value.minOrderQuantity,
    price
  }]
}

const firstSku = (productSkuInfos) => {
  const colorAttributes = productSkuInfos?.map((sku) => {
    const skuAttributes = sku.skuAttributes[0] // 获取每个 SKU 中的第一个 skuAttribute（颜色）
    return {
      ...skuAttributes,
      skuId: sku.skuId
    }
  })
  const uniqueColors = colorAttributes?.filter((value, index, self) => {
    return index === self.findIndex((t) => t.valueTrans === value.valueTrans)
  })
  firstrAttributes.value = uniqueColors

  currentFirstSku.value = uniqueColors?.[0]?.valueTrans
  secondSku(productSkuInfos, uniqueColors?.[0], 0)
  getFirstrAttributesImages(uniqueColors)
}

const getFirstrAttributesImages = (uniqueColors) => {
  if (!uniqueColors) {
    return
  }
  const imagesList = []
  uniqueColors.forEach((v) => {
    imagesList.push(v.skuImageUrl)
  })
  store.commit('setFirstrAttributesimages', imagesList)
}

const secondSku = (
  productSkuInfos,
  currentFirstSelectedObj,
  uniqueColorsIndex
) => {
  const sizeList = productSkuInfos?.filter((v) => {
    return (
      v.skuAttributes[0].valueTrans === currentFirstSelectedObj?.valueTrans
    )
  })
  /**
   * sku 没有库存的情况下，将该 sku 移动到列表最后
   */
  const list = sizeList?.map((v) => {
    return { ...v, quantity: 0 }
  }).sort((a, b) => b.amountOnSale > 0 ? 1 : (a.amountOnSale > 0 ? -1 : 1))
  if (Reflect.has(secondAttributesQuantityObj, uniqueColorsIndex)) {
    secondAttributesQuantityList.value = [...secondAttributesQuantityObj[uniqueColorsIndex]]
  } else {
    secondAttributesQuantityList.value = list
    secondAttributesQuantityObj[uniqueColorsIndex] = list
  }

  const priceRangeList = offerData?.value.productSaleInfo?.priceRangeList
  if (!priceRangeList) {
    handleMinPriceRange()
    return
  }

  // 更新secondAttributesQuantityList的sku价格
  secondAttributesQuantityList.value.forEach(item => {
    const price = getPriceByQuantity(totalQuantity.value, offerData.value.productSaleInfo.priceRangeList)
    item.price = price
  })
}

// 点第一个sku
const clickFirstAttributes = (item, index) => {
  firstActivedAttributesIndex.value = index
  currentFirstSku.value = item.valueTrans
  store.commit('setCurrentHoverdImage', item.skuImageUrl)
  secondSku(offerData.value.productSkuInfos, item, index)
  emits('selectedSkuId', item.skuId)
}

const getPriceByQuantity = (quantity, priceRange) => {
  let validPrices = priceRange.filter(item => item.startQuantity <= quantity)
  if (validPrices.length === 0) {
    validPrices = [priceRange[0]]
  }

  const bestMatch = validPrices.reduce((prev, curr) =>
    curr.startQuantity > prev.startQuantity ? curr : prev
  )
  return Number(bestMatch.price)
}

const { judgeCurrency } = useCurrencyJudge()
const updateSkuPrice = () => {
  judgeCurrency()
  const priceRangeList = offerData?.value.productSaleInfo?.priceRangeList
  if (!priceRangeList) return

  let quantity = 0
  Object.keys(secondAttributesQuantityObj).forEach((key) => {
    secondAttributesQuantityObj[key].forEach((item) => {
      quantity += item.quantity
    })
  })

  const price = getPriceByQuantity(quantity, priceRangeList)
  secondAttributesQuantityList.value.forEach(item => {
    item.price = price
  })
}

const attributesSub = (item, index) => {
  if (secondAttributesQuantityList.value[index].quantity <= 0) {
    return
  }
  secondAttributesQuantityList.value[index].quantity -= item.bundleQuantity

  firstSkuTotal()
  postLtogisticFee()
}

const attributesAdd = (item, index) => {
  if (secondAttributesQuantityList.value[index].quantity >= item.amountOnSale) {
    return
  }
  secondAttributesQuantityList.value[index].quantity += item.bundleQuantity

  firstSkuTotal()
  postLtogisticFee()
}

const firstSkuTotal = () => {
  const currentValueTrans =
    secondAttributesQuantityList.value[0].skuAttributes?.[0].valueTrans || ''
  const newfirstList = toRaw(firstrAttributes.value)
  const _index = newfirstList?.findIndex(
    (v) => v.valueTrans === currentValueTrans
  )

  if (_index !== -1) {
    let total = 0
    secondAttributesQuantityList.value.forEach((v) => {
      const quantity = v.quantity ? v.quantity : 0
      total += Number(quantity)
    })

    firstrAttributes.value[_index].total = total
  }
}

// 捆绑数量算法
const calcBundleQuantity = (data) => {
  const bundleQuantity = +data.bundleQuantity
  const halfBundle = bundleQuantity / 2
  let quantity = +data.quantity
  quantity = (Math.floor((quantity + halfBundle) / bundleQuantity)) * bundleQuantity
  if (quantity <= 0) {
    quantity = bundleQuantity
  }
  return quantity
}

const changeAttributes = (item, index) => {
  let value = calcBundleQuantity(item)

  if (value >= item.amountOnSale) {
    value = item.amountOnSale
  }
  if (value <= 0) {
    value = 0
  }
  secondAttributesQuantityList.value[index].quantity = value

  firstSkuTotal()
  postLtogisticFee()
}

const postLtogisticFee = debounce(() => {
  const _offerData = offerData.value
  const skuSales = []
  totalQuantity.value = 0
  Object.entries(secondAttributesQuantityObj).forEach(([, value]) => {
    value.forEach((v) => {
      if (v?.quantity > 0) {
        totalQuantity.value += Number(v.quantity)
        skuSales.push(toRaw(v))
      }
    })
  })

  const mergedArray = skuSales?.map((detail) => {
    const productSkuInfos = _offerData?.productSkuInfos
    const matchingSale = productSkuInfos?.find((sale) => sale.skuId === detail.skuId)
    updateSkuPrice()
    return {
      spuId: _offerData.offerId,
      skuId: detail.skuId,
      quantity: detail.quantity,
      spuName: _offerData.subjectTrans,
      skuImage: matchingSale.skuAttributes?.[0]?.skuImageUrl,
      batchNum: _offerData.minOrderQuantity,
      skuAttributes: matchingSale.skuAttributes
        ? matchingSale.skuAttributes.map((v) => {
          return {
            name: v.attributeNameTrans,
            value: v.valueTrans
          }
        })
        : [],
      price: detail?.price,
      targetPrice: bankersRound(detail?.price * currencyData.value.rate, 2)
    }
  })

  if (!!mergedArray && !mergedArray.length) {
    store.commit('setSupplierFee', {
      supplierFee: 0,
      suppliersName: '',
      suppliersUrl: ''
    })
    store.commit('setMergedArray', [])
    return
  }

  store.commit('setMergedArray', mergedArray)
}, 300)

const resetData = () => {
  for (const key in secondAttributesQuantityObj) {
    if (Array.isArray(secondAttributesQuantityObj[key])) {
      secondAttributesQuantityObj[key].forEach(item => {
        item.quantity = 0
      })
    }
  }
  secondAttributesQuantityList?.value.forEach((item) => {
    item.quantity = 0
  })
  firstrAttributes.value?.forEach((item) => {
    item.total = 0
  })
  noSkuNum.value = 0
}

/**
 * 待 firstrAttributes 初始化完成后，判断 query 是否存在 skuId，若存在则设置默认值
 */
watch(firstrAttributes, (list) => {
  const { skuId } = route.query
  if (list.length === 0 || skuId == null) return

  const selectedIndex = list.findIndex((v) => v.skuId === Number(skuId))
  if (selectedIndex === -1) return
  clickFirstAttributes(list[selectedIndex], selectedIndex)
})

defineExpose({
  resetData
})
</script>

<style lang="less">
@import "./index.less";
</style>
